import * as L from 'leaflet'

const MapaService = {

	adicionaCamadasAreasRegularizadas(imovel, mapa, layers) {

		if(imovel.areasARegularizar.geoArlEmAreaAntropizadaDeclarado) {

			let geoArlEmAreaAntropizadaDeclarado = L.geoJson(JSON.parse(imovel.areasARegularizar.geoArlEmAreaAntropizadaDeclarado), {
				style: { stroke: false, color: '#ff8b1b', fillColor: '#ff8b1b', weight: 3, fillOpacity: 0.8 }
			})

			layers.push({
				id: geoArlEmAreaAntropizadaDeclarado._leaflet_id,
				name: 'Reserva legal em área antropizada',
				active: true,
				color: '#ff8b1b',
				features: geoArlEmAreaAntropizadaDeclarado,
				tipo: 'D'
			})

			geoArlEmAreaAntropizadaDeclarado.addTo(mapa)

		}

		if(imovel.areasARegularizar.geoArlEmAreaAntropizadaCalculado) {

			let geoArlEmAreaAntropizadaCalculado = L.geoJson(JSON.parse(imovel.areasARegularizar.geoArlEmAreaAntropizadaCalculado), {
				style: { stroke: false, color: '#cd5619', fillColor: '#cd5619', weight: 3, fillOpacity: 0.8 }
			})

			layers.push({
				id: geoArlEmAreaAntropizadaCalculado._leaflet_id,
				name: 'Reserva legal em área antropizada',
				active: true,
				color: '#cd5619',
				features: geoArlEmAreaAntropizadaCalculado,
				tipo: 'C'
			})

			geoArlEmAreaAntropizadaCalculado.addTo(mapa)

		}

		if(imovel.areasARegularizar.geoArlEmAreaConsolidadaCalculado) {

			let geoArlEmAreaConsolidadaCalculado = L.geoJson(JSON.parse(imovel.areasARegularizar.geoArlEmAreaConsolidadaCalculado), {
				style: { stroke: false, color: '#9d4615', fillColor: '#9d4615', weight: 3, fillOpacity: 0.8 }
			})

			layers.push({
				id: geoArlEmAreaConsolidadaCalculado._leaflet_id,
				name: 'Reserva legal em área consolidada',
				active: true,
				color: '#9d4615',
				features: geoArlEmAreaConsolidadaCalculado,
				tipo: 'C'
			})

			geoArlEmAreaConsolidadaCalculado.addTo(mapa)

		}

		if(imovel.areasARegularizar.geoArlEmAreaConsolidadaDeclarado) {

			let geoArlEmAreaConsolidadaDeclarado = L.geoJson(JSON.parse(imovel.areasARegularizar.geoArlEmAreaConsolidadaDeclarado), {
				style: { stroke: false, color: '#69341b', fillColor: '#69341b', weight: 3, fillOpacity: 0.8 }
			})

			layers.push({
				id: geoArlEmAreaConsolidadaDeclarado._leaflet_id,
				name: 'Reserva legal em área consolidada',
				active: true,
				color: '#69341b',
				features: geoArlEmAreaConsolidadaDeclarado,
				tipo: 'D'
			})

			geoArlEmAreaConsolidadaDeclarado.addTo(mapa)

		}

		if(imovel.areasARegularizar.geoAppEmAreaAntropizadaDeclarado) {

			let geoAppEmAreaAntropizadaDeclarado = L.geoJson(JSON.parse(imovel.areasARegularizar.geoAppEmAreaAntropizadaDeclarado), {
				style: { stroke: false, color: '#fff58a', fillColor: '#F2E783', weight: 3, fillOpacity: 0.8 }
			})

			layers.push({
				id: geoAppEmAreaAntropizadaDeclarado._leaflet_id,
				name: 'APP em área antropizada',
				active: true,
				color: '#F2E783',
				features: geoAppEmAreaAntropizadaDeclarado,
				tipo: 'D'
			})

			geoAppEmAreaAntropizadaDeclarado.addTo(mapa)

		}

		if(imovel.areasARegularizar.geoAppEmAreaAntropizadaCalculado) {

			let geoAppEmAreaAntropizadaCalculado = L.geoJson(JSON.parse(imovel.areasARegularizar.geoAppEmAreaAntropizadaCalculado), {
				style: { stroke: false, color: '#cbc06c', fillColor: '#cbc06c', weight: 3, fillOpacity: 0.8 }
			})

			layers.push({
				id: geoAppEmAreaAntropizadaCalculado._leaflet_id,
				name: 'APP em área antropizada',
				active: true,
				color: '#cbc06c',
				features: geoAppEmAreaAntropizadaCalculado,
				tipo: 'C'
			})

			geoAppEmAreaAntropizadaCalculado.addTo(mapa)

		}

		if(imovel.areasARegularizar.geoAppEmAreaConsolidadaDeclarado) {

			let geoAppEmAreaConsolidadaDeclarado = L.geoJson(JSON.parse(imovel.areasARegularizar.geoAppEmAreaConsolidadaDeclarado), {
				style: { stroke: false, color: '#998f4d', fillColor: '#998f4d', weight: 3, fillOpacity: 0.8 }
			})

			layers.push({
				id: geoAppEmAreaConsolidadaDeclarado._leaflet_id,
				name: 'APP em área consolidada',
				active: true,
				color: '#998f4d',
				features: geoAppEmAreaConsolidadaDeclarado,
				tipo: 'D'
			})

			geoAppEmAreaConsolidadaDeclarado.addTo(mapa)

		}

		if(imovel.areasARegularizar.geoAppEmAreaConsolidadaCalculado) {

			let geoAppEmAreaConsolidadaCalculado = L.geoJson(JSON.parse(imovel.areasARegularizar.geoAppEmAreaConsolidadaCalculado), {
				style: { stroke: false, color: '#695f30', fillColor: '#695f30', weight: 3, fillOpacity: 0.8 }
			})

			layers.push({
				id: geoAppEmAreaConsolidadaCalculado._leaflet_id,
				name: 'APP em área consolidada',
				active: true,
				color: '#695f30',
				features: geoAppEmAreaConsolidadaCalculado,
				tipo: 'C'
			})

			geoAppEmAreaConsolidadaCalculado.addTo(mapa)

		}

		if(imovel.areasARegularizar.geoAurEmAreaAntropizadaDeclarado) {

			let geoAurEmAreaAntropizadaDeclarado = L.geoJson(JSON.parse(imovel.areasARegularizar.geoAurEmAreaAntropizadaDeclarado), {
				style: { stroke: false, color: '#2821ff', fillColor: '#2821ff', weight: 3, fillOpacity: 0.8 }
			})

			layers.push({
				id: geoAurEmAreaAntropizadaDeclarado._leaflet_id,
				name: 'Área de Uso Restrito em área antropizada',
				active: true,
				color: '#2821ff',
				features: geoAurEmAreaAntropizadaDeclarado,
				tipo: 'D'
			})

			geoAurEmAreaAntropizadaDeclarado.addTo(mapa)

		}

		if(imovel.areasARegularizar.geoAurEmAreaAntropizadaCalculado) {

			let geoAurEmAreaAntropizadaCalculado = L.geoJson(JSON.parse(imovel.areasARegularizar.geoAurEmAreaAntropizadaCalculado), {
				style: { stroke: false, color: '#1e17cd', fillColor: '#1e17cd', weight: 3, fillOpacity: 0.8 }
			})

			layers.push({
				id: geoAurEmAreaAntropizadaCalculado._leaflet_id,
				name: 'Área de Uso Restrito em área antropizada',
				active: true,
				color: '#1e17cd',
				features: geoAurEmAreaAntropizadaCalculado,
				tipo: 'C'
			})

			geoAurEmAreaAntropizadaCalculado.addTo(mapa)

		}

		if(imovel.areasARegularizar.geoAurEmAreaConsolidadaCalculado) {

			let geoAurEmAreaConsolidadaCalculado = L.geoJson(JSON.parse(imovel.areasARegularizar.geoAurEmAreaConsolidadaCalculado), {
				style: { stroke: false, color: '#1d169c', fillColor: '#1d169c', weight: 3, fillOpacity: 0.8 }
			})

			layers.push({
				id: geoAurEmAreaConsolidadaCalculado._leaflet_id,
				name: 'Área de Uso Restrito em área consolidada',
				active: true,
				color: '#1d169c',
				features: geoAurEmAreaConsolidadaCalculado,
				tipo: 'C'
			})

			geoAurEmAreaConsolidadaCalculado.addTo(mapa)

		}

		if(imovel.areasARegularizar.geoAurEmAreaConsolidadaDeclarado) {

			let geoAurEmAreaConsolidadaDeclarado = L.geoJson(JSON.parse(imovel.areasARegularizar.geoAurEmAreaConsolidadaDeclarado), {
				style: { stroke: false, color: '#14126e', fillColor: '#14126e', weight: 3, fillOpacity: 0.8 }
			})

			layers.push({
				id: geoAurEmAreaConsolidadaDeclarado._leaflet_id,
				name: 'Área de Uso Restrito em área consolidada',
				active: true,
				color: '#14126e',
				features: geoAurEmAreaConsolidadaDeclarado,
				tipo: 'D'
			})

			geoAurEmAreaConsolidadaDeclarado.addTo(mapa)

		}

		if(imovel.areasARegularizar.geoAreasForaEmAreaAntropizadaCalculado) {

			let geoAreasForaEmAreaAntropizadaCalculado = L.geoJson(JSON.parse(imovel.areasARegularizar.geoAreasForaEmAreaAntropizadaCalculado), {
				style: { stroke: false, color: '#21ff2a', fillColor: '#21ff2a', weight: 3, fillOpacity: 0.8 }
			})

			layers.push({
				id: geoAreasForaEmAreaAntropizadaCalculado._leaflet_id,
				name: 'Áreas desmatadas fora da RL / APP e AUR em area antropizada',
				active: true,
				color: '#21ff2a',
				features: geoAreasForaEmAreaAntropizadaCalculado,
				tipo: 'C'
			})

			geoAreasForaEmAreaAntropizadaCalculado.addTo(mapa)

		}

		if(imovel.areasARegularizar.geoAreasForaEmAreaAntropizadaDeclarado) {

			let geoAreasForaEmAreaAntropizadaDeclarado = L.geoJson(JSON.parse(imovel.areasARegularizar.geoAreasForaEmAreaAntropizadaDeclarado), {
				style: { stroke: false, color: '#1bc924', fillColor: '#1bc924', weight: 3, fillOpacity: 0.8 }
			})

			layers.push({
				id: geoAreasForaEmAreaAntropizadaDeclarado._leaflet_id,
				name: 'Áreas desmatadas fora da RL / APP e AUR em area antropizada',
				active: true,
				color: '#1bc924',
				features: geoAreasForaEmAreaAntropizadaDeclarado,
				tipo: 'D'
			})

			geoAreasForaEmAreaAntropizadaDeclarado.addTo(mapa)

		}

		if(imovel.areasARegularizar.geoAreasForaEmAreaConsolidadaDeclarado) {

			let geoAreasForaEmAreaConsolidadaDeclarado = L.geoJson(JSON.parse(imovel.areasARegularizar.geoAreasForaEmAreaConsolidadaDeclarado), {
				style: { stroke: false, color: '#159719', fillColor: '#159719', weight: 3, fillOpacity: 0.8 }
			})

			layers.push({
				id: geoAreasForaEmAreaConsolidadaDeclarado._leaflet_id,
				name: 'Áreas desmatadas fora da RL / APP e AUR em area consolidada',
				active: true,
				color: '#159719',
				features: geoAreasForaEmAreaConsolidadaDeclarado,
				tipo: 'D'
			})

			geoAreasForaEmAreaConsolidadaDeclarado.addTo(mapa)

		}

		if(imovel.areasARegularizar.geoAreasForaEmAreaConsolidadaCalculado) {

			let geoAreasForaEmAreaConsolidadaCalculado = L.geoJson(JSON.parse(imovel.areasARegularizar.geoAreasForaEmAreaConsolidadaCalculado), {
				style: { stroke: false, color: '#126312', fillColor: '#126312', weight: 3, fillOpacity: 0.8 }
			})

			layers.push({
				id: geoAreasForaEmAreaConsolidadaCalculado._leaflet_id,
				name: 'Áreas desmatadas fora da RL / APP e AUR em area consolidada',
				active: true,
				color: '#126312',
				features: geoAreasForaEmAreaConsolidadaCalculado,
				tipo: 'C'
			})

			geoAreasForaEmAreaConsolidadaCalculado.addTo(mapa)

		}

	}

}

export default MapaService



// WEBPACK FOOTER //
// ./src/utils/services/mapa.service.js